const productionNetworks = {
  polygon: {
    chainId: '0x89', // Hexadecimal version of 137
    chainName: 'Polygon Mainnet',
    rpcUrls: ['https://polygon-rpc.com/'],
    blockExplorerUrls: ['https://polygonscan.com/'],
    nativeCurrency: {
      name: 'Matic',
      symbol: 'MATIC', // 2-6 characters long
      decimals: 18,
    },
    contractAddress: '0x75beEbcc19e17560Ec92bfB4A52854135126B1d8',
    bridgeContractAddress: '0xdf978A2817A0B8C6050b63814490f28f7ef8f4BD'
  },
  avalanche: {
    chainId: '0xa86a', // Hexadecimal version of 43114
    chainName: 'Avalanche C-Chain',
    rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
    blockExplorerUrls: ['https://snowtrace.io/'],
    nativeCurrency: {
      name: 'Avalanche',
      symbol: 'AVAX', // 2-6 characters long
      decimals: 18,
    },
    contractAddress: '0x7Ce47348F20D6bb03B995867251AA8eB4807d123',
    bridgeContractAddress: '0xe8aA9cCb09aAfBD7029301e79B73354A559810cE'
  },
};

const developmentNetworks = {
  dev1: {
    chainId: '0x4d2',
    chainName: 'DEV1',
    rpcUrls: ['http://127.0.0.1:8545'],
    blockExplorerUrls: ['https://polygonscan.com/'],
    nativeCurrency: {
      name: 'DETH1',
      symbol: 'DETH1', // 2-6 characters long
      decimals: 18,
    },
    contractAddress: '0xAE3Ac5020CecB27F7Fe8f565F407348B23B424EB',
    bridgeContractAddress: '0x03AC898787242d943e8B594c2F4AEaf29CD990d5'
  },
  dev2: {
    chainId: '0x162e',
    chainName: 'DEV2',
    rpcUrls: ['http://127.0.0.1:8546'],
    blockExplorerUrls: ['https://snowtrace.io/'],
    nativeCurrency: {
      name: 'DETH2',
      symbol: 'DETH2', // 2-6 characters long
      decimals: 18,
    },
    contractAddress: '0x94d80465C916F57217B4c3a4BE424a4922C8C2ce',
    bridgeContractAddress: '0x2D67C6b066Ff9638e06C69e683fdbEE6B73654A4'
  },
};

export const networks = process.env.REACT_APP_ENV === 'production' ? productionNetworks : developmentNetworks;
